<section class="go-container">
  <app-form-control-docs class="go-column go-column--100"></app-form-control-docs>

  <go-card id="form-file-upload-control" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Control</h2>
      <go-copy cardId="form-file-upload-control" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          As with most of the form components, the only <code class="code-block--inline">@Input</code>
          required of the file upload component is a <code class="code-block--inline">FormControl</code>.
          The FormControl can be passed in via the <code class="code-block--inline">[control]</code>
          attribute on the &lt;go-file-upload&gt; component.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload [control]="fileControl"></go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-file-upload-label" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Label</h2>
      <go-copy cardId="form-file-upload-label" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          All form components include an <code class="code-block--inline">@Input() label: string;</code>
          that can be used to add a label to the input components.
          In addition to displaying an HTML label, the text passed
          in via the <code class="code-block--inline">[label]</code>
          attribute is used to generate a unique ID to associate the
          label with the input. If no label is passed in, a generic,
          but still unique ID will be generated.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl2"
              label="Most Awesome Picture">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicLabelExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>
 
    </div>
  </go-card>

  <go-card id="form-file-upload-key" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Key</h2>
      <go-copy cardId="form-file-upload-key" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          As stated above the label attribute is used to generate a
          unique ID to associate the label with the input. As this might
          not be desired, the <code class="code-block--inline">@Input() key: string;</code>
          can be used to configure the ID attribute of the input directly.
          Anything passed into the component via the <code class="code-block--inline">[key]</code>
          attribute will be used to both assign the ID to the input and
          associate the label with the input.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl3"
              label="Most Awesome Picture"
              key="most-awesome-picture">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicKeyExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
          <div class="go-column go-column--100">
            <h4 class="go-heading-4 go-heading--underlined">Example Output</h4>
            <p class="go-body-copy">
              Notice in the below example output that the <code class="code-block--inline">key</code> has been assigned
              to both the <code class="code-block--inline">id</code> attribute on
              the input and the <code class="code-block--inline">for</code> attribute
              on the label.
            </p>
            <code
              [highlight]="basicKeyExampleOutput"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-file-upload-hints" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Hints</h2>
      <go-copy cardId="form-file-upload-hints" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Form hints exist to help give more information about the
          inputs they are attached to. The <code class="code-block--inline">@Input() key: Array&lt;string&gt;</code>
          can be used to pass in an array of hints to the file upload component.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl4"
              label="Most Awesome Picture"
              [hints]="hints">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicHintsTemplate"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="basicHintsExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-file-upload-errors" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Errors</h2>
      <go-copy cardId="form-file-upload-errors" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy">
          FormControls all have a <a class="go-link" href="https://angular.io/api/forms/AbstractControl#setErrors">consistent way of setting errors</a>
          via the <code class="code-block--inline">setErrors()</code> function.
          All goponents use this API to display errors on our components, but the
          data needs to be displayed in a specific structure.
        </p>
        <p class="go-body-copy go-body-copy--no-margin">
          By default the input type is set to "Error", however this can be
          overridden as shown below.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl5"
              label="Most Awesome Picture">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicLabelExample"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="basicErrorsExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>
  
  <go-card id="form-file-upload-multiple" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Multiple</h2>
      <go-copy cardId="form-file-upload-multiple" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may want to be able to upload multiple files in an array. This can be achieved through
          the <code class="code-block--inline">@Input multiple: boolean = false;</code> binding. Setting multiple
          to true will allow the user to select multiple files instead of just one.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl6"
              label="Most Awesome Pictures"
              [multiple]="true">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicMultipleExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card
    id="form-file-upload-reset"
    class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Reset</h2>
      <go-copy cardId="form-file-upload-reset" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may need to reset the state of the file upload component. This can be achieved through
          the <code class="code-block--inline">reset()</code> method on the component. Upload a file and use
          the reset button in the example below to see this in action.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl9"
              label="Most Awesome Pictures"
              #fileUploadReset>
            </go-file-upload>
            <br>
            <go-button
              (handleClick)="resetFileUpload()">
              Reset
            </go-button>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code [highlight]="basicResetExample_html">
            </code>
            <code
              [highlight]="basicResetExample_ts"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-file-upload-loading" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Loading</h2>
      <go-copy cardId="form-file-upload-loading" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          A loading state can be triggered through the <code class="code-block--inline">@Input isLoading: boolean = false;</code>
          binding. Setting <code class="code-block--inline">is-loading</code> to true will disable the file upload and show
          a loading spinner in the drop box.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-file-upload
              [control]="fileControl7"
              label="Most Awesome Pictures"
              [isLoading]="true">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicLoadingExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-file-upload-theme" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Theme</h2>
      <go-copy cardId="form-file-upload-theme" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          A dark or light theme can be triggered through the <code class="code-block--inline">@Input theme: 'dark' | 'light' = 'light';</code>
          binding. The theme signifies which color of background the element is being placed upon. A light theme will be good for a light background,
          while a dark theme would be better for something like being placed in the off canvas which has a dark background.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50 go-column--dark">
            <h4 class="go-heading-4 go-heading--underlined go-form__label--dark">View</h4>
            <go-file-upload
              [control]="fileControl8"
              label="Most Awesome Pictures"
              theme="dark">
            </go-file-upload>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicThemeExample"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>
</section>
